module.exports = __webpack_public_path__ + "img/palette.dbf0982.png";